/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './select-sensors.scss';

/* eslint-disable import/no-unresolved, import/default */

import selectSensorsTemplate from './select-sensors.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.client.selectSensorsTable', [])
    .directive('agSelectSensorsTable', SelectSensorsTable)
    .name;

/*@ngInject*/
function SelectSensorsTable() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            sensorLines: '<',
            selectedSensor: '<',
            enabledSensors: '<',
            selectedSensorLines: '=',
            selectedSiloSensors: '=',
            temperatureContent: '=',
            moistureContent: '='

        },
        controller: SelectSensorsTableController,
        controllerAs: 'vm',
        templateUrl: selectSensorsTemplate
    };
}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function SelectSensorsTableController($scope, $filter, $element, $translate, agTypes) {

    let vm = this;

    vm.agTypes = agTypes;

    vm.selectSensorsTableBody = null;
    vm.selectSensorsTableHeader = null;

    vm.selectSensorsTableWidth = selectSensorsTableWidth;
    vm.toggleSensorCableSelect = toggleSensorCableSelect;
    vm.isSensorCableSelect = isSensorCableSelect;
    vm.isSensorCableIndeterminate = isSensorCableIndeterminate;
    vm.toggleSensorRowSelect = toggleSensorRowSelect;
    vm.isSensorRowSelect = isSensorRowSelect;
    vm.isSensorRowIndeterminate = isSensorRowIndeterminate;
    vm.toggleAllSensors = toggleAllSensors;
    vm.selectAllEnabledSensors = selectAllEnabledSensors;
    vm.toggleTemperatureContent = toggleTemperatureContent;
    vm.toggleMoistureContent = toggleMoistureContent;
    vm.toggleCO2Content = toggleCO2Content;

    $scope.selectSensorsTableInitWatch = $scope.$watch(function () {
        return angular.element('md-list.ag-select-sensors-table', $element).length;
    }, function (length) {
        if (length) {
            $scope.selectSensorsTableInitWatch();
            var selectSensorsTable = angular.element('md-list.ag-select-sensors-table', $element);
            vm.selectSensorsTableHeader = angular.element('.ag-header-wrapper', selectSensorsTable);
            vm.selectSensorsTableBody = angular.element('#select-sensors-table-body', selectSensorsTable);
            vm.selectSensorsTableHeader.css({width: 'auto'});
            vm.selectSensorsTableBody.scroll(function () {
                var width = vm.selectSensorsTableBody.width() + vm.selectSensorsTableBody[0].scrollLeft + 'px';
                var left = -vm.selectSensorsTableBody[0].scrollLeft + 'px';
                vm.selectSensorsTableHeader.css({
                    left: left,
                    width: width
                });
            });
        }
    });

    $scope.$watch('vm.sensorLines', function () {
        if (vm.sensorLines) {
            reset();
            vm.sensorsLoading = true;
            vm.isMoistureContentDisabled = false;
            vm.isCO2ContentDisabled = false;

            var disabledSensors = computeDisabledSensors();
            var selectedSensorTelemetryType;

            var moistureSensorLines = $filter('filter')(vm.sensorLines, {type: agTypes.deviceType.moistureSensorLines});
            if (!moistureSensorLines.length) {
                vm.isMoistureContentDisabled = true;
            }

            var co2SensorLines = $filter('filter')(vm.sensorLines, {type: agTypes.deviceType.co2SensorLines});
            if (!co2SensorLines.length) {
                vm.isCO2ContentDisabled = true;
            }

            for (var i = 0; i < vm.sensorLines.length; i++) {
                var sensorLine = vm.sensorLines[i];
                vm.maxSensorsCount = Math.max(vm.maxSensorsCount, sensorLine.sensorCount);
            }

            for (var row = vm.maxSensorsCount - 1; row >= 0; row--) {
                var sensorRow = {
                    sensorName: $translate.instant('ag.silo.sensor') + ' ' + (row + 1),
                    data: []
                };
                for (var col = 0; col < vm.sensorLines.length; col++) {
                    sensorLine = vm.sensorLines[col];
                    var sensorData = {
                        lineNum: sensorLine.lineNum,
                        index: row,
                        hasSensor: row < sensorLine.sensorCount,
                        selected: false,
                        isMoisture: false,
                        isCO2: false,
                        enabled: true,
                        type: sensorLine.type
                    };
                    if (disabledSensors && disabledSensors[sensorData.lineNum].length) {
                        if (disabledSensors[sensorData.lineNum].indexOf(sensorData.index) !== -1) {
                            sensorData.enabled = false;
                        }
                    }
                    var moistureSensors = angular.fromJson(sensorLine.moistureSensors);
                    if (moistureSensors) {
                        var moistureNumbers = moistureSensors.sensorNumbers;
                    }
                    var co2Sensors = angular.fromJson(sensorLine.co2Sensors);
                    if (co2Sensors) {
                        var co2Numbers = co2Sensors.sensorNumbers;
                    }
                    if ((sensorLine.type === agTypes.deviceType.moistureSensorLines || sensorLine.type === agTypes.deviceType.co2SensorLines)
                        && moistureNumbers && moistureNumbers.length) {
                        if (moistureNumbers.indexOf(sensorData.index + 1) !== -1) {
                            sensorData.isMoisture = true;
                        }
                    }
                    if (sensorLine.type ===agTypes.deviceType.co2SensorLines && co2Numbers && co2Numbers.length) {
                        if (co2Numbers.indexOf(sensorData.index + 1) !== -1) {
                            sensorData.isCO2 = true;
                        }
                    }
                    if (vm.selectedSensor) {
                        if (sensorData.lineNum === vm.selectedSensor.lineNum && sensorData.index === vm.selectedSensor.index) {
                            sensorData.selected = true;
                            vm.selectedSensorLines.push($filter('filter')(vm.sensorLines, {lineNum: sensorData.lineNum}, true)[0]);
                            vm.selectedSiloSensors.push(sensorData);
                            selectedSensorTelemetryType = vm.selectedSensor.telemetryType;
                            vm.selectedSensor = null;
                        }
                    }
                    sensorRow.data.push(sensorData);
                }
                vm.sensorsData.push(sensorRow);
            }
            if (selectedSensorTelemetryType && selectedSensorTelemetryType === agTypes.telemetry.type.moisture) {
                vm.moistureContent = true;
                toggleMoistureContent();
                vm.temperatureContent = false;
                toggleTemperatureContent();
                vm.co2Content = false;
                toggleCO2Content();
            } else if (selectedSensorTelemetryType && selectedSensorTelemetryType === agTypes.telemetry.type.co2) {
                vm.co2Content = true;
                vm.moistureContent = false;
                vm.temperatureContent = false;
                toggleCO2Content();
                toggleMoistureContent();
                toggleTemperatureContent();
            } else {
                vm.moisterHighlight = false;
                vm.co2Highlight = false;
            }
            vm.sensorsLoading = false;

            $scope.$applyAsync(() => {
                startWatchSelectedSensors();
            });
        }
    });

    function startWatchSelectedSensors() {
        vm.watchSelectedSensorsPromise = $scope.$watch('vm.sensorsData', (newVal, prevVal) => {
            if (angular.equals(newVal, prevVal)) {
                return;
            }
            selectedSensorsUpdated();
        }, true);
    }

    function stopWatchSelectedSensors() {
        if (vm.watchSelectedSensorsPromise) {
            vm.watchSelectedSensorsPromise();
            vm.watchSelectedSensorsPromise = null;
        }
    }

    function selectedSensorsUpdated() {
        var selectedSensors = [];
        var selectedLines = [];
        for (var row = vm.sensorsData.length - 1; row >= 0; row--) {
            var sensorRow = vm.sensorsData[row];
            for (var col = 0; col < sensorRow.data.length; col++) {
                var sensorData = sensorRow.data[col];
                if (sensorData.hasSensor && sensorData.selected) {
                    selectedSensors.push(sensorData);
                    if (selectedLines.map((e) => { return e.lineNum }).indexOf(sensorData.lineNum) === -1) {
                        var selectedSensorLine = $filter('filter')(vm.sensorLines, {lineNum: sensorData.lineNum}, true);
                        selectedLines.push(selectedSensorLine[0]);
                    }
                }
            }
        }

        vm.selectedSensorLines = selectedLines;
        vm.selectedSiloSensors = selectedSensors;
    }

    function toggleSensorCableSelect(col) {
        var unselected = null;
        for (var i = vm.sensorsData.length - 1; i >= 0; i--) {
            var sensorRow = vm.sensorsData[i];
            if(sensorRow.data[col].hasSensor) {
                if(!sensorRow.data[col].selected) {
                    unselected = true;
                    break;
                }
            }
        }
        for (var j = vm.sensorsData.length - 1; j >= 0; j--) {
            sensorRow = vm.sensorsData[j];
            if(sensorRow.data[col].hasSensor) {
                sensorRow.data[col].selected = !!unselected;
            }
        }
    }

    function isSensorCableSelect(col) {
        var unselected = null;
        var selected = null;
        for (var i = vm.sensorsData.length - 1; i >= 0; i--) {
            var sensorRow = vm.sensorsData[i];
            if (sensorRow.data[col].hasSensor) {
                if (!sensorRow.data[col].selected) {
                    unselected = true;
                } else {
                    selected = true;
                }
            }
        }
        if (unselected && !selected) {
            return false;
        } else if (selected && !unselected) {
            return true;
        }
    }

    function isSensorCableIndeterminate(col) {
        var unselected = null;
        var selected = null;
        for (var i = vm.sensorsData.length - 1; i >= 0; i--) {
            var sensorRow = vm.sensorsData[i];
            if (sensorRow.data[col].hasSensor) {
                if (!sensorRow.data[col].selected) {
                    unselected = true;
                } else {
                    selected = true;
                }
            }
        }
        return !!(unselected && selected);
    }

    function toggleSensorRowSelect(row) {
        var unselected = null;
        for (var i = 0; i < vm.sensorsData[row].data.length; i++) {
            if(vm.sensorsData[row].data[i].hasSensor) {
                if(!vm.sensorsData[row].data[i].selected) {
                    unselected = true;
                    break;
                }
            }
        }
        for (var j = 0; j < vm.sensorsData[row].data.length; j++) {
            if(vm.sensorsData[row].data[j].hasSensor) {
                vm.sensorsData[row].data[j].selected = !!unselected;
            }
        }
    }

    function isSensorRowSelect(row) {
        var unselected = null;
        var selected = null;
        for (var i = 0; i < vm.sensorsData[row].data.length; i++) {
            if(vm.sensorsData[row].data[i].hasSensor) {
                if(!vm.sensorsData[row].data[i].selected) {
                    unselected = true;
                } else {
                    selected = true;
                }
            }
        }
        if (unselected && !selected) {
            return false;
        } else if (selected && !unselected) {
            return true;
        }
    }

    function isSensorRowIndeterminate(row) {
        var unselected = null;
        var selected = null;
        for (var i = 0; i < vm.sensorsData[row].data.length; i++) {
            if(vm.sensorsData[row].data[i].hasSensor) {
                if(!vm.sensorsData[row].data[i].selected) {
                    unselected = true;
                } else {
                    selected = true;
                }
            }
        }
        return !!(unselected && selected);
    }

    function toggleTemperatureContent() {
        if (!vm.temperatureContent) {
            for (var row = vm.sensorsData.length - 1; row >= 0; row--) {
                var sensorRow = vm.sensorsData[row];
                for (var col = 0; col < sensorRow.data.length; col++) {
                    var sensorData = sensorRow.data[col];
                    if (sensorData.hasSensor && !sensorData.isMoisture && !sensorData.isCO2) {
                        sensorData.selected = false;
                    }
                }
            }
            readOnlyAllCheckboxes('on');
            if (vm.moistureContent) {
                highlightMoistureSensors('on');
            } else if (vm.co2Content) {
                highlightCO2Sensors('on');
            } else {
                toggleAllSensors('clear');
            }
        } else {
            readOnlyAllCheckboxes('off');
        }
    }

    function toggleMoistureContent() {
        if (vm.moistureContent) {
            highlightMoistureSensors('on');
            vm.moisterHighlight = true;
        } else {
            highlightMoistureSensors('off');
            vm.moisterHighlight = false;
            if (!vm.temperatureContent) {
                toggleAllSensors('clear');
            }
        }
    }

    function toggleCO2Content() {
        if (vm.co2Content) {
            highlightCO2Sensors('on');
            vm.co2Highlight = true;
        } else {
            highlightCO2Sensors('off');
            vm.co2Highlight = false;
            if (!vm.temperatureContent) {
                toggleAllSensors('clear');
            }
        }
    }

    function toggleAllSensors(action) {
        for (var row = vm.sensorsData.length - 1; row >= 0; row--) {
            var sensorRow = vm.sensorsData[row];
            for (var col = 0; col < sensorRow.data.length; col++) {
                var sensorData = sensorRow.data[col];
                if (sensorData.hasSensor) {
                    if (action && action === 'select') {
                        if (vm.temperatureContent) {
                            sensorData.selected = true;
                        } else if (vm.moistureContent && sensorData.isMoisture) {
                            sensorData.selected = true;
                        } else if (vm.co2Content && sensorData.isCO2) {
                            sensorData.selected = true;
                        }
                    } else if (action && action === 'clear') {
                        sensorData.selected = false;
                    }
                }
            }
        }
    }

    function readOnlyAllCheckboxes(action) {
        for (var row = vm.sensorsData.length - 1; row >= 0; row--) {
            var sensorRow = vm.sensorsData[row];
            for (var col = 0; col < sensorRow.data.length; col++) {
                var sensorData = sensorRow.data[col];
                if (sensorData.hasSensor) {
                    if (action && action === 'on') {
                        sensorData.readOnly = true;
                    } else if (action && action === 'off') {
                        sensorData.readOnly = false;
                    }
                }
            }
        }
        for (var i = 0; i < vm.sensorLines.length; i++) {
            if (action && action === 'on') {
                vm.sensorLines[i].readOnly = true;
            } else if (action && action === 'off') {
                vm.sensorLines[i].readOnly = false;
            }
        }
        for (var j = 0; j < vm.sensorsData.length; j++) {
            if (action && action === 'on') {
                vm.sensorsData[j].readOnly = true;
            } else if (action && action === 'off') {
                vm.sensorsData[j].readOnly = false;
            }
        }
    }

    function highlightMoistureSensors(action) {
        for (var row = vm.sensorsData.length - 1; row >= 0; row--) {
            var sensorRow = vm.sensorsData[row];
            for (var col = 0; col < sensorRow.data.length; col++) {
                var sensorData = sensorRow.data[col];
                if (sensorData.hasSensor && sensorData.isMoisture) {
                    if (action && action === 'on') {
                        sensorData.readOnly = false;
                    } else if (action && action === 'off' && !vm.temperatureContent) {
                        sensorData.readOnly = true;
                    }
                }
            }
        }
    }

    function highlightCO2Sensors(action) {
        for (var row = vm.sensorsData.length - 1; row >= 0; row--) {
            var sensorRow = vm.sensorsData[row];
            for (var col = 0; col < sensorRow.data.length; col++) {
                var sensorData = sensorRow.data[col];
                if (sensorData.hasSensor && sensorData.isCO2) {
                    if (action && action === 'on') {
                        sensorData.readOnly = false;
                    } else if (action && action === 'off' && !vm.temperatureContent) {
                        sensorData.readOnly = true;
                    }
                }
            }
        }
    }

    function selectAllEnabledSensors() {
        for (var row = vm.sensorsData.length - 1; row >= 0; row--) {
            var sensorRow = vm.sensorsData[row];
            for (var col = 0; col < sensorRow.data.length; col++) {
                var sensorData = sensorRow.data[col];
                if (sensorData.hasSensor) {
                    if(vm.temperatureContent) {
                        sensorData.selected = sensorData.enabled;
                    } else if (vm.moistureContent && sensorData.isMoisture) {
                        sensorData.selected = sensorData.enabled;
                    } else if (vm.co2Content && sensorData.isCO2) {
                        sensorData.selected = sensorData.enabled;
                    }
                }
            }
        }
    }

    function computeDisabledSensors() {
        let disabledSensors = {};
        if (vm.enabledSensors) {
            let enabledSensors = angular.fromJson(vm.enabledSensors);
            vm.sensorLines.forEach((sensorLine) => {
                let sensorLineDisabledSensors = [];
                let sensorLineEnabledSensors;
                if (enabledSensors[sensorLine.id.id]) {
                    sensorLineEnabledSensors = enabledSensors[sensorLine.id.id];
                } else {
                    sensorLineEnabledSensors = [];
                }
                for (let sensorId = 0; sensorId < sensorLine.sensorCount; sensorId++) {
                    if (sensorLineEnabledSensors.indexOf(sensorId) === -1) {
                        sensorLineDisabledSensors.push(sensorId);
                    }
                }
                disabledSensors[sensorLine.lineNum] = sensorLineDisabledSensors;
            });
        } else {
            disabledSensors = null;
        }
        return disabledSensors;
    }

    $scope.$on('$destroy', function() {
        reset();
    });

    function reset() {
        stopWatchSelectedSensors;
        vm.maxSensorsCount = 0;
        vm.sensorsData = [];
        if (vm.selectSensorsTableHeader) {
            vm.selectSensorsTableHeader.css({width: 'auto'});
        }
    }

    function selectSensorsTableWidth() {
        var hasScroll = false;
        if (vm.selectSensorsTableBody) {
            hasScroll = vm.selectSensorsTableBody[0].scrollHeight > vm.selectSensorsTableBody[0].clientHeight;
        }
        var result = 16 + 95 + (vm.sensorLines ? vm.sensorLines.length : 0) * 30;
        if (hasScroll) {
            result += 15;
        }
        return result;
    }
}